import { hubbleAPI } from './url'

const resource = hubbleAPI + 'public/ct'
export default ($axios) => ({
  addAddressInformation(cartAddressUpdate) {
    if (!cartAddressUpdate) {
      throw new Error(`Missing parameters, customerDetails: ${cartAddressUpdate}`);
    }
    return $axios.post(`${resource}/add-address-information`, cartAddressUpdate)
  }
})
